import { CLEAR_SELECTED_DRIVER, 
  GET_ASSIGN_DRIVER_FAILED, 
  GET_ASSIGN_DRIVER_REQUESTED, 
  GET_ASSIGN_DRIVER_SUCCESS, 
  GET_CANCEL_TRIP_FAILED, 
  GET_CANCEL_TRIP_REQUESTED, 
  GET_CANCEL_TRIP_SUCCESS, 
  GET_INVOICE_DOWNLOAD_FAILED, 
  GET_INVOICE_DOWNLOAD_REQUESTED, 
  GET_INVOICE_DOWNLOAD_SUCCESS, 
  GET_INVOICE_FAILED, 
  GET_INVOICE_REQUESTED, 
  GET_INVOICE_SUCCESS, 
  GET_SOS_ALERT_FAILED, 
  GET_SOS_ALERT_REQUESTED, 
  GET_SOS_ALERT_SUCCESS, 
  GET_TRIP_FAILED, 
  GET_TRIP_REQUESTED, 
  GET_TRIP_SUCCESS, 
  CLEAR_SELECTED_TRIP,
  GET_SHARE_TRIP_REQUESTED,
  GET_SHARE_TRIP_SUCCESS,
  GET_SHARE_TRIP_FAILED
 } from "resources/actionTypes";

const initialState = {
  userTrip: [],
  loading: false,
  error: null,
};
const initalSosAlertState = {
  userSOSAlert: [],
  loading: false,
  error: null,
}
const initialStateCancel = {
  userCancelTrip: [],
  loading: false,
  error: null,
};
const initialStateAssignDriver = {
  userAssignDriver: [],
  loading: false,
  error: null,
}
const initialStateInvoice = {
  userInvoice: [],
  loading: false,
  error: null,
}
const initialStateInvoiceDownload = {
  userInvoiceDownload: [],
  loading: false,
  error: null,
}

//migrated ShareTrip Reducer

// const initialState = {
//   userTrip: [],
//   loading: false,
//   error: null,
// };
const intialShareTripState = {
  userShareTrip: [],
  loading: false,
  error:null,
}

export function userTrip(state = initialState, action) {
  switch (action.type) {
    case GET_TRIP_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_TRIP_SUCCESS:
      return {
        ...state,
        loading: false,
        userTrip: action.userTrip,
      };
    case GET_TRIP_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    case CLEAR_SELECTED_TRIP:
      return null;
    default:
      return state;
  }
}

export function userSOSAlert(state = initalSosAlertState, action) {
  switch (action.type) {
    case GET_SOS_ALERT_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SOS_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
        userSOSAlert: action.userSOSAlert,
      };
    case GET_SOS_ALERT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userCancelTrip(state = initialStateCancel, action) {
  switch (action.type) {
    case GET_CANCEL_TRIP_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCEL_TRIP_SUCCESS:
      return {
        ...state,
        loading: false,
        userCancelTrip: action.userCancelTrip,
      };
    case GET_CANCEL_TRIP_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAssignDriver(state = initialStateAssignDriver, action) {
  switch (action.type) {
    case GET_ASSIGN_DRIVER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ASSIGN_DRIVER_SUCCESS:
      return {
        ...state,
        loading: false,
        userAssignDriver: action.userAssignDriver,
      };
    case GET_ASSIGN_DRIVER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userInvoice(state = initialStateInvoice, action) {
  switch (action.type) {
    case GET_INVOICE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_INVOICE_SUCCESS:
      return {
        ...state,
        loading: false,
        userInvoice: action.userInvoice,
      };
    case GET_INVOICE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userInvoiceDownload(state = initialStateInvoiceDownload, action) {
  switch (action.type) {
    case GET_INVOICE_DOWNLOAD_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_INVOICE_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        userInvoiceDownload: action.userInvoiceDownload,
      };
    case GET_INVOICE_DOWNLOAD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

//migrated ShareTrip Reducer

export function userShareTrip(state = intialShareTripState, action){
  switch(action.type){
    case GET_SHARE_TRIP_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SHARE_TRIP_SUCCESS:
      return{
        ...state,
        loading: false,
        userShareTrip: action.userShareTrip,
      }
    case GET_SHARE_TRIP_FAILED:
      return{
        ...state,
        loading: false,
        error: action.message,
      }
    default:
      return state;
  }
}